<template>
    <div
        v-show="show"
        class="kgr-region kgr-region--default"
    >
        <kgr-loader v-if="loading" />
        <template v-else>
            <h3 class="kgr-headline kgr-headline--h3">
                {{ $t('Offene Posten') }}
            </h3>
            <div class="kgr-row">
                {{ $t('Unvollständig bezahlte Rechnungen') }}: <span class="kgr-text kgr-text--bold">{{ openItems.notPaidInvoices }}</span><br />
                {{ $t('Offener Gesamtbetrag') }}: <span class="kgr-text kgr-text--bold">{{ formatAmount }}</span>
                <div v-if="memberCreditGeneralAmount">
                    {{ $t('Allgemeines Guthaben') }}: <span class="kgr-text kgr-text--bold">{{ memberCreditGeneralAmount.format() }}</span>
                </div>
                <div v-if="memberCreditDepartmentAmount">
                    {{ $t('Abteilungsguthaben') }}: <span class="kgr-text kgr-text--bold">{{ memberCreditDepartmentAmount.format() }}</span>
                </div>
            </div>
            <div>
                <button
                    class="kgr-button kgr-button--accent kgr-button--small kgr-button--wide"
                    :disabled="buttonDisabled"
                    @click="csvExport"
                >
                    {{ $t('CSV-Export') }}
                </button>
                <button
                    class="kgr-button kgr-button--accent kgr-button--small kgr-button--wide"
                    :disabled="buttonDisabled"
                    @click="excelExport"
                >
                    {{ $t('Excel-Export') }}
                </button>
            </div>
        </template>
    </div>
</template>

<script>
import Loader from '../../common/Loading.vue';
import Money from '../../../js/dto/Money.js';
import OpenItems from '../../../js/dto/OpenItems.js';
import OpenItemsExportRepository from '../../../js/repository/OpenItemsExportRepository.js';

export default {
    components: {
        'kgr-loader': Loader,
    },
    props: {
        clubId: {
            type: Number,
            required: false,
            default: null,
        },
        memberId: {
            type: Number,
            required: false,
            default: null,
        },
        openItems: {
            type: OpenItems,
            required: true,
        },
        show: {
            type: Boolean,
            required: true,
            default: false,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
        query: {
            type: String,
            required: true,
        },
        memberCreditGeneralAmount: {
            type: Money,
            required: false,
            default: null,
        },
        memberCreditDepartmentAmount: {
            type: Money,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            pendingExport: false,
        };
    },
    computed: {
        formatAmount() {
            return `${Money.fromData(this.openItems).toLocalizedString()} ${this.openItems.currency}`;
        },
        buttonDisabled() {
            return this.pendingExport || this.openItems.notPaidInvoices === 0;
        },
    },
    methods: {
        csvExport() {
            this.pendingExport = true;
            if (this.clubId !== null) {
                OpenItemsExportRepository.getCsvByClubIdAndQuery(this.clubId, this.query)
                    .then(() => {})
                    .catch(() => this.$notify.error('error.loadingData'))
                    .finally(() => this.pendingExport = false);
            } else if (this.memberId !== null) {
                OpenItemsExportRepository.getCsvByMemberIdAndQuery(this.memberId, this.query)
                    .then(() => {})
                    .catch(() => this.$notify.error('error.loadingData'))
                    .finally(() => this.pendingExport = false);
            }
        },
        excelExport() {
            this.pendingExport = true;
            if (this.clubId !== null) {
                OpenItemsExportRepository.getXlsxByClubIdAndQuery(this.clubId, this.query)
                    .then(() => {})
                    .catch(() => this.$notify.error('error.loadingData'))
                    .finally(() => this.pendingExport = false);
            } else if (this.memberId !== null) {
                OpenItemsExportRepository.getXlsxByMemberIdAndQuery(this.memberId, this.query)
                    .then(() => {})
                    .catch(() => this.$notify.error('error.loadingData'))
                    .finally(() => this.pendingExport = false);
            }
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
